import React from "react";
/**
 * A generic plugin view that mounts the given react component.
 * The react component's props should extends `ReactPluginViewComponentProps`, containing prosemirror's EditorView instance.
 *
 * @remarks The component will be rendered whenever prosemirror state is changed, so make sure to optimize the rendering of the component
 * using react's `memo` or similar methods, also considering `prevState` prop is updated on each render.
 */
export class ReactPluginView {
    static create(config) {
        return (view) => new ReactPluginView(view, config);
    }
    constructor(view, config) {
        this.view = view;
        this.config = config;
        this.prevState = null;
        this.Component = () => {
            const ReactComponent = this.config.component;
            return (React.createElement(ReactComponent, { view: this.view, prevState: this.prevState, ...this.config.extraProps }));
        };
        this.root = this.createRoot();
        if (this.config.domInsertMode === "append") {
            view.dom.parentNode.append(this.root);
        }
        else {
            view.dom.parentNode.prepend(this.root);
        }
        this.render();
    }
    update(view, prevState) {
        this.view = view;
        this.prevState = prevState;
        this.render();
    }
    destroy() {
        this.config.portalContainer.remove(this.root);
    }
    createRoot() {
        const root = document.createElement("div");
        root.classList.add("editor-react-plugin-wrapper");
        const { className } = this.config;
        const { displayName, name } = this.config.component;
        if (displayName || name) {
            root.classList.add(`editor-react-plugin-wrapper--${className || displayName || name}`);
        }
        return root;
    }
    render() {
        this.config.portalContainer.render(this.root, this.Component);
    }
}
